import { Plus, Trash2 } from "lucide-react";
import { money } from "../api";

const GST = [0, 5, 12, 18, 28];
export const blankService = () => ({ description: "", qty: 1, unit: "lump sum", rate: "", gst_rate: 18, sac: "" });
export const serviceTotal = (s) => (Number(s.qty) || 0) * (Number(s.rate) || 0) * (1 + Number(s.gst_rate) / 100);
export const cleanServices = (rows) => {
  const bad = rows.find((s) => (!s.description.trim() && s.rate !== "") || (s.description.trim() && !(Number(s.qty) > 0)));
  if (bad) throw new Error(bad.description.trim() ? `Enter a quantity above 0 for "${bad.description}"` : "Every service with a rate needs a description");
  return rows.filter((s) => s.description.trim()).map((s) => ({ ...s, qty: Number(s.qty), rate: Number(s.rate) || 0, gst_rate: Number(s.gst_rate) }));
};

export function ServicesEditor({ rows, onChange }) {
  const set = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="services-editor" data-testid="services-editor">
      <div className="services-head"><b>Event services</b><small>Catering, projector, decoration… each with its own GST rate. Use qty 1 for a lump sum.</small></div>
      {rows.map((s, i) => (
        <div className="service-row" key={i} data-testid={`service-row-${i}`}>
          <input placeholder="Service (e.g. Catering – veg lunch)" value={s.description} onChange={(e) => set(i, "description", e.target.value)} data-testid={`service-desc-${i}`} />
          <input type="number" min="0.001" step="any" title="Quantity" value={s.qty} onChange={(e) => set(i, "qty", e.target.value)} data-testid={`service-qty-${i}`} />
          <input placeholder="Unit" value={s.unit} onChange={(e) => set(i, "unit", e.target.value)} data-testid={`service-unit-${i}`} />
          <input type="number" min="0" step="0.01" placeholder="Rate ₹" value={s.rate} onChange={(e) => set(i, "rate", e.target.value)} data-testid={`service-rate-${i}`} />
          <select value={s.gst_rate} onChange={(e) => set(i, "gst_rate", e.target.value)} data-testid={`service-gst-${i}`}>{GST.map((r) => <option key={r} value={r}>{r}% GST</option>)}</select>
          <input placeholder="SAC (optional)" value={s.sac} onChange={(e) => set(i, "sac", e.target.value)} data-testid={`service-sac-${i}`} />
          <span className="service-total">{money(serviceTotal(s))}</span>
          <button type="button" className="icon-button" onClick={() => onChange(rows.filter((_, j) => j !== i))} data-testid={`service-remove-${i}`}><Trash2 size={13} /></button>
        </div>
      ))}
      <button type="button" className="secondary-button" onClick={() => onChange([...rows, blankService()])} data-testid="service-add"><Plus size={13} /> Add service</button>
    </div>
  );
}

export function BillingFields({ f, set, prefix }) {
  return (
    <>
      <label>Company name (B2B)<input value={f.company || ""} onChange={(e) => set("company", e.target.value)} placeholder="Optional — for a GST invoice in the company's name" data-testid={`${prefix}-company`} /></label>
      <label>Company GSTIN<input value={f.gstin || ""} maxLength={15} onChange={(e) => set("gstin", e.target.value.toUpperCase())} placeholder="15-character GSTIN" data-testid={`${prefix}-gstin`} /></label>
      <label>Billing address<input value={f.address || ""} onChange={(e) => set("address", e.target.value)} data-testid={`${prefix}-address`} /></label>
    </>
  );
}
